import { ROUTE_PATHS } from '../config/navigation';

// Anasayfa alt sırasındaki form / prosedür / doküman kartlarının varsayılanı.
// Admin panelinden (İçerik Yönetimi) "dashboard.documentColumns" ile değiştirilebilir;
// yönetilen veri yoksa bu liste fallback olarak kullanılır.
export const DEFAULT_DOCUMENT_COLUMNS = [
  {
    key: 'forms',
    title: 'Formlar',
    icon: 'bx bxs-copy',
    path: `${ROUTE_PATHS.documents}?kategori=form-sablon`,
    links: [
      { label: 'İzin ve Mazeret Formları', path: `${ROUTE_PATHS.documents}?kategori=form-sablon`, featured: true },
      { label: 'Masraf ve Avans Formları', path: `${ROUTE_PATHS.documents}?kategori=form-sablon` },
      { label: 'Başvuru ve Talep Şablonları', path: `${ROUTE_PATHS.documents}?kategori=form-sablon` }
    ]
  },
  {
    key: 'procedures',
    title: 'Prosedürler ve Talimatlar',
    icon: 'bx bxs-book',
    path: `${ROUTE_PATHS.documents}?kategori=politika-prosedur`,
    links: [
      { label: 'İş Sağlığı ve Güvenliği', path: `${ROUTE_PATHS.documents}?kategori=politika-prosedur`, featured: true },
      { label: 'Kalite ve Uyum Politikaları', path: `${ROUTE_PATHS.documents}?kategori=politika-prosedur` },
      { label: 'Etik ve Çalışma İlkeleri', path: `${ROUTE_PATHS.documents}?kategori=politika-prosedur` }
    ]
  },
  {
    key: 'other',
    title: 'Diğer Dokümanlar',
    icon: 'bx bxs-folder-open',
    path: ROUTE_PATHS.documents,
    links: [
      { label: 'Çalışan El Kitabı', path: `${ROUTE_PATHS.documents}?kategori=kurumsal-kaynaklar`, featured: true },
      { label: 'Organizasyon Şeması', path: ROUTE_PATHS.documents },
      { label: 'Kurumsal Sunumlar', path: ROUTE_PATHS.documents }
    ]
  }
];

// Yönetilen veriyi güvenli biçimde normalize eder; eksik/bozuksa varsayılana düşer.
export const hydrateDocumentColumns = (columns) => {
  if (!Array.isArray(columns) || columns.length === 0) {
    return DEFAULT_DOCUMENT_COLUMNS;
  }

  return columns
    .filter((column) => column && column.title)
    .map((column, columnIndex) => ({
      key: column.key || `col-${columnIndex}`,
      title: column.title,
      icon: column.icon || 'bx bxs-folder-open',
      path: column.path || ROUTE_PATHS.documents,
      links: Array.isArray(column.links)
        ? column.links
            .filter((link) => link && link.label)
            .map((link) => ({
              label: link.label,
              path: link.path || ROUTE_PATHS.documents,
              featured: Boolean(link.featured)
            }))
        : []
    }));
};

// Öne çıkan (featured) linkler üste gelecek şekilde sırala — diğer sıra korunur.
export const sortFeaturedFirst = (links = []) =>
  [...links].sort((a, b) => Number(Boolean(b.featured)) - Number(Boolean(a.featured)));
